import type { SessionResult } from "./schemas/sessionResult.js";

// Pure timestamp resolver for SessionResult rows. Lifted from apps/mobile so
// every surface that orders session results (mobile Progress + the Home form
// badge + the web-rnw console) reads the start time the same way.
//
// startedAtMs comes from the wire as of api 1.81.0 (extracted from the DDB
// sk). Falls back to computedAt-parse so the panels still render on a
// mixed-version response, just with the historical timeline collapsed against
// today. Without the wire field the dashboard misaligns every windowing math
// because backfilled SessionResult.computedAt == "now".
// See [[project_progress_redesign]].
export const startedAtMsOf = (
  raw: unknown,
  fallback: SessionResult,
): number => {
  if (raw && typeof raw === "object") {
    const v = (raw as Record<string, unknown>).startedAtMs;
    if (typeof v === "number" && Number.isFinite(v) && v > 0) return v;
  }
  const ms = Date.parse(fallback.computedAt);
  return Number.isFinite(ms) ? ms : Date.now();
};
